/**
 * @flow
 * @format
 */

export const StepState = {
  NOT_STARTED: 'NOT_STARTED',
  COMPLETE: 'COMPLETE',
  STARTED: 'STARTED',
  ERROR: 'ERROR',
  DISABLED: 'DISABLED',
};

export const Steps = {
  STEP_ONE: 'STEP_ONE',
  STEP_TWO: 'STEP_TWO',
  STEP_THREE: 'STEP_THREE',
  STEP_FOUR: 'STEP_FOUR',
  STEP_FIVE: 'STEP_FIVE',
  STEP_ANALYSIS: 'STEP_ANALYSIS',
  SCHEMATIC: 'SCHEMATIC',
  BOM: 'BOM',
  REPORT: 'REPORT',
};

export const defaults = {
  DECIMAL_PLACES: 5,
  EXP_THRESHOLD: 5,
};



// WEBPACK FOOTER //
// ./src/utils/constants.js